import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetReferralCodeV1Response } from './get-referral-code-v1-response';
import { getReferralCodeV1ResponseSchema } from './get-referral-code-v1-response';

export async function getReferralCodeV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetReferralCodeV1Response>> {
  return getRequest<IGetReferralCodeV1Response>({
    path: '/account/referral-code/v1',
    schema: getReferralCodeV1ResponseSchema,
    options,
  });
}
